import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => (
  <header style={{ background: '#fff', borderBottom: '1px solid #E0D0B8', padding: '14px 0', position: 'sticky', top: 0, zIndex: 100 }}>
    <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none' }}>
        <div style={{ width: 36, height: 36, background: 'linear-gradient(135deg, #D4A843, #BF8C2C)', borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🍿</div>
        <span style={{ fontSize: 18, fontWeight: 700, color: '#2D1A00', letterSpacing: 1 }}>CHAKNA POINT</span>
      </Link>
      <nav style={{ display: 'flex', gap: '24px', fontSize: 14, fontWeight: 500 }}>
        <Link to="/about-us" style={{ color: '#6B6B6B' }}>About</Link>
        <Link to="/contact-us" style={{ color: '#6B6B6B' }}>Contact</Link>
        <Link to="/privacy-policy" style={{ color: '#6B6B6B' }}>Privacy</Link>
      </nav>
    </div>
  </header>
);

export default Header;
